import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { checkDebugAccess } from '../api/api'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { title: 'debug tools', developerOnly: true }
  },
  {
    path: '/notinapp',
    name: 'Notinapp',
    component: () => import('../views/Notinapp.vue')
  },
  {
    path: '/live/',
    name: 'Live',
    component: () => import('../views/layout/Main.vue'),
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('../views/live/List.vue'),
        meta: { title: '直播列表' }
      },
      {
        path: 'detail/:id',
        name: 'detail',
        component: () => import('../views/live/Detail.vue'),
        meta: { requiresAuth: true, title: '直播详情', onlyInApp: false }
      },
      {
        path: 'outdetail/:id',
        name: 'outdetail',
        component: () => import('../views/live/Outdetail.vue'),
        meta: { title: '直播详情' }
      },
      {
        path: 'bind/:id',
        name: 'bind',
        component: () => import('../views/live/Bind.vue'),
        meta: { requiresAuth: true, title: '直播绑定' }
      }
    ]
  },
  {
    path: '/zhuanti',
    name: 'Zhuanti',
    component: () => import('../views/zhuanti/List.vue'),
    meta: { title: '掌上温岭App活动专题', keepAlive: true }
  },
  {
    path: '/fzp/',
    name: 'Fzp',
    component: () => import('../views/fzp/Main.vue'),
    children: [
      {
        path: 'list',
        name: 'fzp_list',
        component: () => import('../views/fzp/List.vue'),
        meta: {
          requiresAuth: true,
          title: '看视频 学反诈 赢大奖',
          keepAlive: true, onlyInApp: false
        }
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('../views/fzp/Test.vue'),
        meta: { requiresAuth: true, title: '反诈骗答一答', onlyInApp: false }
      },
      {
        path: 'phb',
        name: 'phb',
        component: () => import('../views/fzp/Phb.vue'),
        meta: { requiresAuth: true, title: '反诈骗比一比', onlyInApp: false }
      },
      {
        path: 'video/:id',
        name: 'video',
        component: () => import('../views/fzp/Video.vue'),
        meta: { requiresAuth: true, title: '反诈骗视频观看页', onlyInApp: false }
      },
      {
        path: 'rule',
        name: 'rule',
        component: () => import('../views/fzp/Rule.vue'),
        meta: { requiresAuth: true, title: '活动规则', onlyInApp: false }
      },
      {
        path: 'prize',
        name: 'prize',
        component: () => import('../views/fzp/Prize.vue'),
        meta: { requiresAuth: true, title: '我的奖品', onlyInApp: false }
      }
    ]
  },
  {
    path: '/fanzha/',
    name: 'Fanzha',
    component: () => import('../views/fanzha/Main.vue'),
    children: [
      {
        path: 'list',
        name: 'fanzha_list',
        component: () => import('../views/fanzha/List.vue'),
        meta: {
          requiresAuth: false,
          title: '看视频 学反诈 赢大奖',
          keepAlive: true
        }
      },
      {
        path: 'test',
        name: 'fanzha_test',
        component: () => import('../views/fanzha/Test.vue'),
        meta: { requiresAuth: true, title: '反诈骗答一答' }
      },
      {
        path: 'phb',
        name: 'fanzha_phb',
        component: () => import('../views/fanzha/Phb.vue'),
        meta: { requiresAuth: true, title: '反诈骗比一比' }
      },
      {
        path: 'video/:id',
        name: 'fanzha_video',
        component: () => import('../views/fanzha/Video.vue'),
        meta: { requiresAuth: true, title: '反诈骗视频观看页' }
      },
      {
        path: 'rule',
        name: 'fanzha_rule',
        component: () => import('../views/fanzha/Rule.vue'),
        meta: { requiresAuth: true, title: '活动规则' }
      },
      {
        path: 'prize',
        name: 'fanzha_prize',
        component: () => import('../views/fanzha/Prize.vue'),
        meta: { requiresAuth: true, title: '我的奖品' }
      }
    ]
  },
  {
    path: '/fanzha2023/',
    name: 'Fanzha2023',
    component: () => import('../views/fanzha2023/Main.vue'),
    redirect: 'fanzha2023/home',
    children: [
      {
        path: 'home',
        name: 'fanzha_home_fanzha2023',
        component: () => import('../views/fanzha2023/Home.vue'),
        meta: {
          requiresAuth: true,
          title: '反诈童你在一起',
          keepAlive: true
        }
      },
      {
        path: 'list',
        name: 'fanzha_list_fanzha2023',
        component: () => import('../views/fanzha2023/List.vue'),
        meta: {
          requiresAuth: true,
          title: '反诈童你在一起',
        }
      },
      {
        path: 'phb',
        name: 'fanzha_phb_fanzha2023',
        component: () => import('../views/fanzha2023/Phb.vue'),
        meta: { requiresAuth: true, title: '排行榜' }
      },
      {
        path: 'video/:id',
        name: 'fanzha_video_fanzha2023',
        component: () => import('../views/fanzha2023/Video.vue'),
        meta: { requiresAuth: true, title: '反诈童你在一起' }
      },
      {
        path: 'rule',
        name: 'fanzha_rule_fanzha2023',
        component: () => import('../views/fanzha2023/Rule.vue'),
        meta: { requiresAuth: true, title: '活动规则' }
      },
      {
        path: 'mine',
        name: 'fanzha_mine_fanzha2023',
        component: () => import('../views/fanzha2023/Mine.vue'),
        meta: { requiresAuth: true, title: '我的' }
      },
      {
        path: 'duihuan',
        name: 'fanzha_duihuan_fanzha2023',
        component: () => import('../views/fanzha2023/Duihuan.vue'),
        meta: {
          requiresAuth: true,
          title: '兑换',
        }
      },
    ]
  },
  {
    path: '/jfwm',
    name: 'Jfwm',
    redirect: '/jfwm/index',
    component: () => import('../views/creative/2022/jfwm/Main.vue'),
    children: [
      {
        path: 'index',
        name: 'jfwm_index',
        component: () => import('../views/creative/2022/jfwm/Index.vue'),
        meta: { requiresAuth: true, title: '城北街道，家风文明“五美”打卡活动' }
      },
      {
        path: 'upload/:mei?',
        name: 'jfwm_upload',
        component: () => import('../views/creative/2022/jfwm/Upload.vue'),
        meta: {
          requiresAuth: true,
          title: '【上传】城北街道，家风文明“五美”打卡活动'
        }
      },
      {
        path: 'sign',
        name: 'jfwm_sign',
        component: () => import('../views/creative/2022/jfwm/Sign.vue'),
        meta: {
          requiresAuth: true,
          title: '【登记】城北街道，家风文明“五美”打卡活动'
        }
      },
      {
        path: 'list',
        name: 'jfwm_list',
        component: () => import('../views/creative/2022/jfwm/List.vue'),
        meta: {
          requiresAuth: true,
          title: '【我的】城北街道，家风文明“五美”打卡活动'
        }
      }
    ]
  },
  {
    path: '/fm',
    name: 'Fm',
    redirect: '/fm/index',
    component: () => import('../views/fm/Main.vue'),
    children: [
      {
        path: 'index',
        name: 'fm_index',
        component: () => import('../views/fm/Index.vue'),
        meta: { requiresAuth: false, title: '温岭广播电台FM103.6' }
      }
    ]
  },
  {
    path: '/creative',
    name: 'Creative',
    component: () => import('../views/layout/Main.vue'),
    children: [
      {
        path: 'kjj2022',
        name: 'Kjj2022',
        component: () => import('../views/creative/2022/kjj/Index.vue'),
        meta: {
          requiresAuth: true,
          title: '奖品太疯狂，点点手指就抱走，温岭科技局，全民互动“有礼”！'
        }
      },
      {
        path: 'tmnc',
        name: 'Tmnc',
        component: () => import('../views/creative/2022/tmnc/Main.vue'),
        redirect: '/creative/tmnc/index',
        children: [
          {
            path: 'index',
            name: 'TmncIndex',
            component: () => import('../views/creative/2022/tmnc/Index.vue'),
            meta: { requiresAuth: true, title: '甜蜜共富农场' }
          },
          {
            path: 'mine',
            name: 'TmncMine',
            component: () => import('../views/creative/2022/tmnc/Mine.vue'),
            meta: { requiresAuth: true, title: '甜蜜共富农场——我的' }
          },
          {
            path: 'Choujiang',
            name: 'TmncChoujiang',
            component: () => import('../views/creative/2022/tmnc/Choujiang.vue'),
            meta: { requiresAuth: true, title: '甜蜜共富农场——抽奖' }
          },
          {
            path: 'Farm',
            name: 'TmncFarm',
            component: () => import('../views/creative/2022/tmnc/Farm.vue'),
            meta: { requiresAuth: true, title: '甜蜜共富农场——农场' }
          },
          {
            path: 'Plant',
            name: 'TmncPlant',
            component: () => import('../views/creative/2022/tmnc/Plant.vue'),
            meta: { requiresAuth: true, title: '甜蜜共富农场——种植' }
          }
        ]
      },
      {
        path: 'wmcj2022',
        name: 'Wmcj2022',
        component: () => import('../views/creative/2022/wmcj/Index.vue'),
        meta: {
          requiresAuth: false,
          title: '文明创建十大融媒体行动'
        }
      }
    ]
  },
  {
    path: '/shaonianjingxiao',
    name: 'shaonianjingxiao',
    component: () => import('../views/shaonianjingxiao/Main.vue'),
    redirect: '/shaonianjingxiao/index',
    children: [
      {
        path: 'index',
        name: 'snjx_index',
        component: () => import('../views/shaonianjingxiao/Index.vue'),
        meta: { requiresAuth: true, title: '温岭少年警校线上学习平台' }
      },
      {
        path: 'videos',
        name: 'snjx_videos',
        component: () => import('../views/shaonianjingxiao/Videos.vue'),
        meta: { requiresAuth: true, title: '阿狮学堂集合' }
      },
      {
        path: 'video/:id',
        name: 'snjx_video',
        component: () => import('../views/shaonianjingxiao/Video.vue'),
        meta: { requiresAuth: true, title: '阿狮学堂视频详情' }
      },
      {
        path: 'article/:id',
        name: 'snjx_article',
        component: () => import('../views/shaonianjingxiao/Article.vue'),
        meta: { requiresAuth: true, title: '阿狮学堂文章详情' }
      },
      {
        path: 'register',
        name: 'snjx_register',
        component: () => import('../views/shaonianjingxiao/Register.vue'),
        meta: {
          requiresAuth: true,
          title: '新建学生信息',
        }
      },
      {
        path: 'record',
        name: 'snjx_record',
        component: () => import('../views/shaonianjingxiao/Record.vue'),
        meta: {
          requiresAuth: true,
          title: '积分记录',
        }
      },
    ]
  },
  {
    path: '/notfound',
    name: 'Notfound',
    component: () => import('../views/Notfound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

let debugAccessGrantedUntil = 0
router.beforeEach((to, from, next) => {
  const developerOnly = to.matched.some(route => route.meta && route.meta.developerOnly)
  if (!developerOnly || process.env.NODE_ENV === 'development') {
    next()
    return
  }
  if (Date.now() < debugAccessGrantedUntil) {
    next()
    return
  }
  checkDebugAccess().then(response => {
    const allowed = response && response.code === 1 && response.data && response.data.allowed === true
    if (allowed) {
      debugAccessGrantedUntil = Date.now() + 5 * 60 * 1000
      next()
      return
    }
    next({ path: '/notfound', replace: true })
  }).catch(() => {
    next({ path: '/notfound', replace: true })
  })
})

export default router
